import script from "./CompanyRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyRegister.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__